import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

import Navbar from '../common/navbar'
import Footer from '../common/footer'
import { Paper } from '@mui/material'

import { useNavigate, useLocation } from 'react-router-dom';

const StudentBlog = (props) => {

    const { state } = useLocation();
    // console.log("state", state);

    const navigate = useNavigate()

    const { schools } = useContext(SchoolContex)
    const [test, setTest] = useState(0);

    const [data, setData] = useState({
        title: '',
        date: '',
        school: '',
        metaTitle: '',
        keywords: '',
        metaDesc: ''
    })


    useEffect(() => {
        if(!state){
            navigate('/StudentLogin' , {state : {from: 'blog'}});
        }
    }, []);




    const [cover, setCover] = useState();
    const [thumb, setThumb] = useState();
    const [details, setDetails] = useState();
    const [load, setLoad] = useState(false);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        if (e.target.name === 'thumb') {
            setThumb(e.target.files[0])

        }
        if (e.target.name === 'cover') {
            setCover(e.target.files[0]);

        }
    }

    const handleDetails = (e) => {
        setDetails(e)
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }

    const Details = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={details}
                onChange={handleDetails}
            />
        ), [test])
    }


    const saveEvent = () => {
        // console.log("==>", data);
        // console.log("==>", details);
        // return;
        setLoad(true)

        const date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let currentDate = `${year}-${month}-${day}`;
        // console.log(currentDate);


        const postData = new FormData();
        postData.append('title', data.title)
        postData.append('date', currentDate)
        postData.append('school', data.school)
        postData.append('cover', cover)
        postData.append('thumb', cover)
        postData.append('details', details)
        postData.append('metaTitle', data.title)
        postData.append('keywords', data.keywords)
        postData.append('metaDesc', data.metaDesc)
        postData.append('author', state.name)
        postData.append('author_id', state.id)
        postData.append('authorType', 'student')
        // postData.append('isApprove', 0)
        postData.append('isApprove', 0)


        axios.post(`${process.env.REACT_APP_MAIN_API}saveBlog`, postData)
            .then((res) => {
                // console.log(res);
                // props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

                navigate('/StudentDash', { state: state })

            })
            .catch((err) => {
                // console.log('err', err);
                setLoad(false)
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    React.useEffect(() => {
        setData({
            ...props.modalData,
            metaDesc: props.modalData?.metaDescription
        });
        // console.log(props.modalData, 'props.modalData');
        setDetails(props.modalData?.details)
        setTest(test + 1)
    }, [props])

    // console.log(props, 'props.modalData');

    return (
        <>
            <Navbar />
            <div className='container '>
                <Paper className='p-md-3'>
                    <div className='row'>

                        <div className='col-md-12 p-2'>
                            <label htmlFor="">Blog Title:</label>
                            <input type="text" className='form-control' name="title" value={data.title} onChange={handleInput} id="" />
                        </div>

                        {/* <div className='col-md-6 p-2'>
                        <label htmlFor="">Date:</label>
                        <input type="date" className='form-control' name="date" value={data.date} onChange={handleInput} id="" />
                    </div> */}

                        <div className='col-md-6 p-2'>
                            <label htmlFor="">School:</label>

                            <select className='form-control' name='school' value={data.school} onChange={handleInput}>
                                <option>--selest--</option>
                                {schools && schools.map((sch) =>
                                (
                                    <option value={sch.schoolName}>{sch.schoolName}</option>
                                ))}
                                <option value="All">All</option>
                            </select>

                        </div>


                        <div className='col-md-6 p-2'>
                            <label htmlFor="">Cover Image: </label>
                            <input type="file" className='form-control' name="cover" onChange={handleImg} id="" />
                            {
                                props.modalData?.cover &&
                                <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${props.modalData.cover}`} height={50} alt='blog cover image' />
                            }
                        </div>
                        {/* <div className='col-md-6 p-2'>
                        <label htmlFor="">Thumbnails: </label>
                        <input type="file" className='form-control' name="thumb" onChange={handleImg} id="" />
                        {
                            props.modalData?.thumb &&
                            <img src={`${process.env.REACT_APP_BACKEND}blogs/thumb/${props.modalData.thumb}`} height={50} />
                        }
                    </div> */}

                        <div className='col-md-12 p-2'>
                            <label htmlFor="">Content:</label>
                            {Details()}
                        </div>

                        {/* <div className='col-md-6 p-2'>
                        <label htmlFor="">Meta Title:</label>
                        <input type="text" className='form-control' name="metaTitle" value={data.metaTitle} onChange={handleInput} id="" />
                    </div>
                    <div className='col-md-6 p-2'>
                        <label htmlFor="">Keywords:</label>
                        <input type="text" className='form-control' name="keywords" value={data.keywords} onChange={handleInput} id="" />
                    </div>
                    <div className='col-md-12 p-2'>
                        <label htmlFor="">Meta Description:</label>
                        <input type="text" className='form-control' name="metaDesc" value={data.metaDesc} onChange={handleInput} id="" />
                    </div> */}

                        <div className='col-md-12 p-4 text-center'>
                            <Button variant='contained' disabled={load ? true : false} onClick={saveEvent}>Save Blog</Button>
                        </div>



                    </div>
                </Paper>
            </div>
            <Footer />
        </>
    )
}

export default StudentBlog;